export default __webpack_public_path__ + "static/media/classroomAdmin-blue.27f83fb6.svg";